<template>
  <div class="money">
    <b-card
      border-variant="light"
      no-body
    >
      <b-row class="m-0 pt-4">
        <b-col lg="6">
          <la-polar
            aria-hidden="true"
            class="d-block mx-auto"
            :colors="colors"
            :data="values"
            :height="290"
            :width="300"
          >
            <la-pie
              prop="pv"
              show-label
              label-prop="name"
              :radius="[60, 100]"
            />
          </la-polar>
        </b-col>

        <b-col lg="6">
          <ul class="d-block mx-auto px-0 list-unstyled text-left">
            <li
              v-for="i in values.length"
              :key="i"
              class="m-0"
            >
              <i :class="`fas fa-circle fc-o${9 - i}`"></i>
              <span v-html="$t(`sfs.why.money.list[${i-1}]`)"></span>
              <b v-html="`${values[i-1].name}`"></b>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { Polar, Pie } from 'laue';

export default {
  components: {
    LaPolar: Polar,
    LaPie: Pie,
  },

  data() {
    const percent = {
      style: 'percent',
      maximumFractionDigits: 1,
    };

    return {
      values: [
        { // Ressources humaines
          name: this.$n(+this.$t('metrics.pie-rh') / 100, percent),
          pv: this.$t('metrics.pie-rh'),
        },
        { // Serveurs et domaines
          name: this.$n(+this.$t('metrics.pie-tech') / 100, percent),
          pv: this.$t('metrics.pie-tech'),
        },
        { // Frais de fonctionnement
          name: this.$n(+this.$t('metrics.pie-op') / 100, percent),
          pv: this.$t('metrics.pie-op'),
        },
        { // Interventions et projets ext.
          name: this.$n(+this.$t('metrics.pie-event') / 100, percent),
          pv: this.$t('metrics.pie-event'),
        },
        { // Communication
          name: this.$n(+this.$t('metrics.pie-com') / 100, percent),
          pv: this.$t('metrics.pie-com'),
        },
        { // Prestations projets
          name: this.$n(+this.$t('metrics.pie-pro') / 100, percent),
          pv: this.$t('metrics.pie-pro'),
        },
        { // Frais bancaires
          name: this.$n(+this.$t('metrics.pie-bank') / 100, percent),
          pv: this.$t('metrics.pie-bank'),
        },
      ],
      colors: ['#9c3c1c', '#cc4e13', '#dd6418', '#fc8e3a', '#f6a055', '#fbc98d', '#fee7c8'],
    };
  },
};
</script>
